import React from "react";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { SegmentedControl } from "../../../components/SegmentedControl";

export const GoalDirectionSegmentedControl = (props: {
  goalDirection: "greater" | "less";
  setGoalDirection(_: "greater" | "less"): void;
}) => {
  const intl_tokens = useIntlTokens();
  return (
    <SegmentedControl
      style={{ maxWidth: 200 }}
      values={[intl_tokens.MoreThan, intl_tokens.LessThan]}
      selectedIndex={props.goalDirection === "greater" ? 0 : 1}
      onChange={(e) => {
        const direction =
          e.nativeEvent.selectedSegmentIndex === 0 ? "greater" : "less";
        props.setGoalDirection(direction);
      }}
    />
  );
};
